@use "../../../styles/Constants.scss" as Constants;
@use "../../../styles/Colors.scss" as Colors;

$var-shadow: 0 1px 4px 0 Colors.$col-shadow;

.notification-settings {
	height: 100%;
	width: 100%;
	padding: 0l;

	&__description {
		padding: Constants.$val-spacing-l;
	}
}
